// extracted by mini-css-extract-plugin
export default {"ErrorMessage":"Input_ErrorMessage__Gu-uQ"};